import { useHistory } from 'react-router';
import * as React from 'react';

import { updateSearch } from 'bernie-core';

import { ILocalization, useLocalization } from '@shared-ui/localization-context';
import { LodgingOneKeyBurnSwitch } from '@shared-ui/lodging-property-offers';

import { Level, liveAnnounce } from 'uitk-react-utils';
import { UitkSpacing } from 'uitk-react-spacing';

import { History, Location } from 'history';
import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

const getHandleClick = (history: History, location: Location, l10n: ILocalization) => (isChecked: boolean) => {
  updateSearch({ history, location, newParams: { useRewards: String(isChecked) }, replace: true });
  setTimeout(() => liveAnnounce(l10n?.formatText(isChecked ? 'common.pointsApplied' : 'common.pointsRemoved'), Level.POLITE), 500);
};

interface LodgingOneKeyBurnSwitchWrapperProps extends SharedUiWrapperProps {
  showBorder?: boolean;
}

const LodgingOneKeyBurnSwitchWrapper: React.FC<LodgingOneKeyBurnSwitchWrapperProps> = React.memo(({ inputs, showBorder }) => {
  const history = useHistory();
  const location = history.location;
  const l10n = useLocalization();

  return (
    <UitkSpacing margin={{ block: 'three' }}>
      <LodgingOneKeyBurnSwitch inputs={inputs} handler={getHandleClick(history, location, l10n)} skipSsr={true} showBorder={showBorder} />
    </UitkSpacing>
  );
});

LodgingOneKeyBurnSwitchWrapper.displayName = 'LodgingOneKeyBurnSwitchWrapper';
export const SharedUiLodgingOneKeyBurnSwitchWrapper = withSharedUiPropertyOffers(LodgingOneKeyBurnSwitchWrapper);
